// @ts-check

class SocialShare extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.#addEventListeners();
	}

	#addEventListeners() {
		this.addEventListener("click", (event) => {
			const target = /** @type {HTMLElement} */ (event.target);

			if (!target) {
				return;
			}

			const toggleButton = target.classList.contains("js-SocialShare-toggle")
				? target
				: target.closest(".js-SocialShare-toggle");

			const socialShareLink = target.classList.contains(".SocialShare-link")
				? target
				: target.closest(".SocialShare-link");

			const isMailtoLink = socialShareLink
				?.getAttribute("href")
				?.startsWith("mailto:");

			if (socialShareLink) {
				const pageUrl = window.location.href;
				const shareUrl = /** @type {string} */ (
					socialShareLink.getAttribute("href")?.replace("{{ url }}", pageUrl)
				);

				if (isMailtoLink) {
					socialShareLink.setAttribute("href", shareUrl);
				} else {
					event.preventDefault();
					window.open(shareUrl, "beckSocialShare", "noopener");
				}
			}

			if (toggleButton) {
				this.#handleToggleButtonClick(toggleButton);
			}
		});

		this.addEventListener("keydown", (event) => {
			if (event.key === "Escape") {
				this.#closeSocialShare();
			}
		});

		document.addEventListener("click", (event) => {
			const target = /** @type {HTMLElement} */ (event.target);
			if (target !== this && !this.contains(target)) {
				this.#closeSocialShare();
			}
		});
	}

	#handleToggleButtonClick(toggleButton) {
		const card = /** @type {HTMLDivElement} */ (
			this.querySelector(`#${toggleButton.getAttribute("aria-controls")}`)
		);
		const isExpanded = toggleButton.getAttribute("aria-expanded") === "true";

		if (!card) {
			return;
		}

		card.toggleAttribute("hidden");
		toggleButton.setAttribute("aria-expanded", !isExpanded);

		// Focus the card after browser completed layout re-rendering
		// caused by toggleAttribute("hidden")
		requestAnimationFrame(() => {
			card.focus();
		});
	}

	#closeSocialShare() {
		const toggleButton = /** @type {HTMLButtonElement} */ (
			this.querySelector(".js-SocialShare-toggle")
		);
		const card = /** @type {HTMLDivElement} */ (
			this.querySelector(".js-SocialShare-card")
		);

		if (!toggleButton || !card) {
			return;
		}

		// Only focus the toggle button if the card was actually visible
		const wasVisible = !card.hidden;
		card.hidden = true;
		toggleButton.ariaExpanded = "false";
		if (wasVisible) {
			toggleButton.focus();
		}
	}
}

customElements.define("social-share", SocialShare);
